const locales = 'nb-NO';
export function formatTimeFromDate(date: string): string {
    const d = new Date(date);
    return d.toLocaleTimeString(locales, { hour: '2-digit', minute: '2-digit' });
}
